export const TIME_RANGE = [...Array(25)].map(
  (_, index) => `${index < 10 ? `0${index}:00` : `${index}:00`}`,
);

const MIDNIGHT = '24:00';

export const setToMidnight = (dateTime) => {
  dateTime.setHours(23);
  dateTime.setMinutes(59);
};

export const setTimesOnSelectedDates = (fromTime, toTime, selectedDates) => {
  const workingDateTime = selectedDates.slice();
  if (fromTime === MIDNIGHT) {
    setToMidnight(workingDateTime[0]);
  } else {
    workingDateTime[0].setHours(fromTime.split(':')[0]);
    workingDateTime[0].setMinutes(0);
  }
  if (toTime === MIDNIGHT) {
    setToMidnight(workingDateTime[1]);
  } else {
    workingDateTime[1].setHours(toTime.split(':')[0]);
    workingDateTime[1].setMinutes(0);
  }
  return workingDateTime;
};

export const isSameDayDateRange = (transactionFilter) =>
  transactionFilter.selectedDates[0].getFullYear() ===
    transactionFilter.selectedDates[1].getFullYear() &&
  transactionFilter.selectedDates[0].getMonth() === transactionFilter.selectedDates[1].getMonth() &&
  transactionFilter.selectedDates[0].getDate() === transactionFilter.selectedDates[1].getDate();
